import { Component } from 'react';
import i18n from '@/i18n';
import type { ErrorInfo, ReactNode } from 'react';
import { Button, Result } from 'antd';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('[ErrorBoundary] Uncaught error:', error.message, errorInfo.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            padding: 24,
          }}
        >
          <Result
            status="error"
            title={i18n.t('common.somethingWrong')}
            subTitle={i18n.t('common.somethingWrongDesc')}
            extra={[
              <Button key="retry" onClick={this.handleReset}>
                {i18n.t('common.tryAgain')}
              </Button>,
              <Button key="reload" type="primary" onClick={this.handleReload}>
                {i18n.t('common.reloadPage')}
              </Button>,
            ]}
          />
        </div>
      );
    }

    return this.props.children;
  }
}
